module.exports = __webpack_public_path__ + "img/adgsystems.ce48e3ba.jpeg";